import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
//import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";

export default [
  {
    prop: "serviceRequestID",
    name: "NO",
    label: "NO",
    width: 80,
    sortable: true
    //formatter: SLAClolorStatus
  },
  {
    prop: "clientName",
    name: "Cliente",
    label: "Cliente",
    minWidth: 300
    /*formatter: row => {
      if (row.CustomerName === null && row.Customer !== null) {
        return row.Customer.Name;
      }
      return row.CustomerName;
    }*/
  },
  {
    name: "Clasificacion",
    label: "Clasificación",
    prop: "ValoracionID",
    width: 130,
    sortable: true
    //formatter: row => (row.Customer ? row.Customer.Clasification : "")
  },
  /*
  {
    prop: "ServiceRequestType.Description",
    name: "Solictud",
    label: "Solictud",
    sortable: true,
    //    formatter: row => {
    //return row.ServiceRequestType ? row.ServiceRequestType.Description : "";
    //},
    minWidth: 200
  },*/
  {
    prop: "statusDescription",
    name: "Estado",
    label: "Estado",
    sortable: true,
    minWidth: 100
  },
  {
    prop: "cantidad",
    name: "Cantidad",
    label: "Cantidad",
    width: 110,
    sortable: true
    //formatter: row =>
    //row.DeviceQuantity ?? row.DeviceQuantity > 1 ? row.DeviceQuantity : ""
  },
  {
    prop: "servicesDescription",
    name: "Servicio",
    label: "Servicio",
    minWidth: 250,
    sortable: true
  },
  {
    prop: "Tecnico",
    name: "Tecnico",
    label: "Técnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnician.ImageUrl"
    }
  },
  //   {
  //     prop: "RequestDate",
  //     name: "Creado",
  //     label: "Creado",
  //     formatter: DatetimeFormatter,
  //     minWidth: 190,
  //     sortable: true,
  //     attrs: {
  //       onlyDate: true
  //     }
  //   },
  {
    prop: "duedate",
    name: "Limite",
    label: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "closeDate",
    name: "Fecha Cierre",
    label: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "SLA",
    name: "SLA",
    label: "SLA",
    minWidth: 75,
    sortable: true
    //formatter: row => (row.SLAHoursToRespond ? row.SLAHoursToRespond : "")
  }
];
